export default [
  {
    name: 'project_start_date',
    component_path: 'modules/templates/blocks/project/ProjectDate',
    settings: {
      text: 'start_date',
      value: 'start_date'
    }
  }
]